import { LayoutDashboard } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { Tooltip, TooltipTrigger } from "@/components/ui/tooltip";

/**
 * The header entry to the "Dashboard & settings" workspace (ADR-032) — the legacy hamburger, as a toggle: pressed while
 * the workspace is open. Shown to everyone (the Dashboard pages are ungated; only the sidebar adapts to rights).
 * Disabled while a manual is being edited: the editor holds a lock and a dirty buffer, and the route refuses to
 * unmount it — this disabled state is the affordance, the route rule the enforcement.
 */
export function WorkspaceButton({ isOpen, isDisabled = false, onPress }: { isOpen: boolean; isDisabled?: boolean; onPress: () => void }) {
  const { t } = useTranslation();
  const label = t("workspace.dashboardAndSettings");
  return (
    <TooltipTrigger delay={0}>
      <Button variant={isOpen ? "default" : "ghost"} size="icon" aria-label={label} aria-pressed={isOpen} isDisabled={isDisabled} onPress={onPress}>
        <LayoutDashboard aria-hidden="true" className="size-4" />
      </Button>
      <Tooltip placement="bottom">{isDisabled ? t("workspace.finishEditingFirst") : label}</Tooltip>
    </TooltipTrigger>
  );
}
